const current = function( ) {

  let tables = [];

  document.querySelectorAll('.news-toggle').forEach((toggle) => {
    tables.push(toggle.dataset.ref_item);
  });

  tables.forEach((table) => {
    if(document.getElementById(table)) {
      if(!document.getElementById(table).classList.contains('processed')) {
        document.getElementById(table).classList.add('is-active');
        document.querySelector('.news-toggle[data-ref_item="'+table+'"]').style.display = 'block';
        document.getElementById(table).classList.add('processed')
      }
    } else {
      document.querySelector('.news-toggle[data-ref_item="'+table+'"]').style.display = 'none';
    }
  });

  const form = document.getElementById('views-exposed-form-actueel-block-1');
  if (form && !form.classList.contains('sectie-processed')) {
    form.addEventListener('submit', (e) => {
      let queryParams = new URLSearchParams(window.location.search);
      if (queryParams.has('sectie')) {
        const sectie = queryParams.get('sectie');
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'sectie';
        hiddenInput.value = sectie;
        form.appendChild(hiddenInput);
      }
    });
    form.classList.add('sectie-processed');
  }






  document.querySelectorAll('.news-toggle').forEach((toggle) =>  {

    if (!toggle.classList.contains('processed')) {

      let ref = toggle.dataset.ref_item;

      toggle.addEventListener('click', () =>  {

        if(toggle.classList.contains('is-active')) {
          document.querySelectorAll('.news-toggle').forEach((toggle) =>  toggle.classList.remove('is-active'));
          tables.forEach((table) => {
            if(document.getElementById(table)) {
              document.getElementById(table).classList.add('is-active');
            }
          });
          let queryParams = new URLSearchParams(window.location.search);
          queryParams.delete('sectie');
          history.pushState(null, null, "?"+queryParams.toString());


        } else {
          document.querySelectorAll('.news-toggle').forEach((toggle) =>  toggle.classList.remove('is-active'));


          reset();


          if(document.getElementById(ref)) {
            document.getElementById(ref).classList.add('is-active');

            let queryParams = new URLSearchParams(window.location.search);

            queryParams.set('sectie', toggle.dataset.param);
            history.pushState(null, null, "?"+queryParams.toString());
          }
          toggle.classList.add('is-active')

        }




      });



      toggle.classList.add('processed');
    }
  });

  function reset() {
    tables.forEach((table) => {
      if(document.getElementById(table)) {
        document.getElementById(table).classList.remove('is-active');

      }
    });
  }



  function init() {
    let queryParams = new URLSearchParams(window.location.search);
    if (queryParams.has('sectie')) {
      reset();
      let selector = '.news-toggle[data-param="'+queryParams.get('sectie')+'"]';
      let toggle = document.querySelector(selector);
      toggle.classList.add('is-active')
      let ref = toggle.dataset.ref_item;
      if(document.getElementById(ref)) {
        document.getElementById(ref).classList.add('is-active');
      }
    }
  }

  init();
  window.addEventListener("popstate", (event) => {
    init();
  });




}









export default current;
